<template>
  <div id="community" class="c-content">
    <banner-general :content="banner"></banner-general>

    <div class="c-community__technology c-standard">
      <h3 class='title_h3'>{{ technology.title }}</h3>
      <p>{{ technology.text }}</p>
      <div class="c-community__technology--items">
        <div class="c-community__technology--item" v-for="(item,index) in technology.items" :key="index">
          <img :src="item.img" :alt="item.text">
          <p>{{item.text}}</p>
        </div>
      </div>
    </div>

    <exhibition-items :content="exhibition"></exhibition-items>

    <div class="c-publicity">
      <div class="c-publicity__flex c-publicity__flex--right">
        <div class="c-publicity__block" style='height: 47vh'>
          <div class="c-publicity__block--image" :style="{backgroundImage:'url('+ publicity[0].img.url +')'}"></div>
        </div>
        <div class="c-publicity__block c-publicity__block--text" :style="'height: 47vh;background-color:'+ publicity[0].text.color">
          <div class="c-publicity__absolute c-publicity__dark">
            <h3 class='title_h3'>
              <p>{{publicity[0].text.title}}</p>
              <span>
                <b>{{publicity[0].text.enSmallTitle}}</b>
                {{publicity[0].text.enTitle}}
              </span>
            </h3>
            <p class='c-publicity__text'>{{publicity[0].text.text}}</p>
            <p class='c-publicity__watch'>
              <q-btn outline class='c-publicity__watch--btn' @click='routeTo(publicity[0].text.link)' :label="community.more" padding="3px 2.5em" style='border-radius:0; color: #C6C6C6; line-height: 1.5em'/>
            </p>
          </div>
        </div>
      </div>

      <div class="c-publicity__flex c-publicity__flex--left" style="margin-top: 10px">
        <div class="c-publicity__block c-publicity__block--text" :style="'height: 47vh;background-color:'+ publicity[1].text.color">
          <div class="c-publicity__absolute c-publicity__lighter">
            <h3 class='title_h3'>
              <p>{{publicity[1].text.title}}</p>
              <span>
                <b>{{publicity[1].text.enSmallTitle}}</b>
                {{publicity[1].text.enTitle}}
              </span>
            </h3>
            <p class='c-publicity__text'>{{publicity[1].text.text}}</p>
            <p class='c-publicity__watch'>
              <q-btn outline class='c-publicity__watch--btn' @click='routeTo(publicity[1].text.link)' :label="community.more" padding="3px 2.5em" style='border-radius:0; color: #164687; line-height: 1.5em'/>
            </p>
          </div>
        </div>
        <div class="c-publicity__block" style='height: 47vh'>
          <div class="c-publicity__block--image" :style="{backgroundImage:'url('+ publicity[1].img.url +')'}"></div>
        </div>
      </div>
  </div>

  </div>
</template>

<script>
  // import api from '../../api'
  // import axios from 'axios'
  import BannerGeneral from '../layout/bannerGeneral.vue'
  import ExhibitionItems from '../layout/exhibitionItems.vue'

  export default {
    name: 'community',
    components: {
      'q-btn': Quasar.QBtn,
      'banner-general': BannerGeneral,
      'exhibition-items': ExhibitionItems
    },
    data(){
      return {
        community: {
          more: this.$t('common.more')
        },
        banner: {
          type: '1',
          img: require('../../assets/img/banner_community.jpg'),
          title: this.$t('homepage.publicity.publicity_1.title'),
          content: this.$t('homepage.publicity.publicity_1.content'),
        },
        technology: {
          title: this.$t('community.technology.title'),
          text: "",
          items: [
            {img: require('../../assets/img/icon_iot.png'), text: this.$t('community.technology.technology_1')},
            {img: require('../../assets/img/icon_cloud.png'), text: this.$t('community.technology.technology_2')},
            {img: require('../../assets/img/icon_ai.png'), text: this.$t('community.technology.technology_3')},
            {img: require('../../assets/img/icon_face.png'), text: this.$t('community.technology.technology_4')},
            {img: require('../../assets/img/icon_video.png'), text: this.$t('community.technology.technology_5')},
            {img: require('../../assets/img/icon_bigdata.png'), text: this.$t('community.technology.technology_6')},
          ]
        },
        exhibition: [
          {url: require('../../assets/img/solution_villa.png'), link:'programCommunity', title: this.$t('program_community.theme_1.title'), content: this.$t('program_community.theme_1.content'), color: '#FFFFFF', contentColor:'#E0E0E0', bgColor: '#164687', btnColor: '#C6C6C6'},
          {url: require('../../assets/img/solution_apartment.png'), link:'programCommunity', title: this.$t('program_community.theme_2.title'), content: this.$t('program_community.theme_2.content'), color: '#FFFFFF', contentColor:'#CBCBCB', bgColor: '#808080', btnColor: '#C6C6C6'},
          {url: require('../../assets/img/solution_office.png'), link:'programCommunity', title: this.$t('program_community.theme_3.title'), content: this.$t('program_community.theme_3.content'), color: '#232323', contentColor:'#181818', bgColor: '#F1F4F1', btnColor: '#164687'},
          {url: require('../../assets/img/solution_hotel.png'), link:'programCommunity', title: this.$t('program_community.theme_4.title'), content: this.$t('program_community.theme_4.content'), color: '#FFFFFF', contentColor:'#CBCBCB', bgColor: '#434543', btnColor: '#C6C6C6'}
        ],
        publicity: [
          {
            text: {
              link:'icommunity',
              title: this.$t('community.publicity.publicity_1.title'),
              enTitle: this.$t('community.publicity.publicity_1.title_en'),
              enSmallTitle: this.$t('community.publicity.publicity_1.title_small'), 
              color: '#2F303A', 
              theme:'dark',
              text: this.$t('community.publicity.publicity_1.content')
            },
            img: {url:require('../../assets/img/publicity_3.jpg'), des:''},
            direction: 'row',
          },
          {
            text: {
              link:'ilifestyle',
              title: this.$t('community.publicity.publicity_2.title'),
              enTitle: this.$t('community.publicity.publicity_2.title_en'),
              enSmallTitle: this.$t('community.publicity.publicity_2.title_small'), 
              color: '#F1F4F1', 
              theme:'lighter',
              text: this.$t('community.publicity.publicity_2.content')
            },
            img: {url:require('../../assets/img/publicity_4.jpg'), des:''},
            direction: 'row-reverse',
          },
        ],
      }
    },
    computed: {

    },
    created () {

    },
    methods: {
      routeTo(link, index){
        this.$router.push({
          name: link,
          query: {
            id: index
          }
        })
      },
    },
  }
</script>

<style>

</style>
